
export interface IPortfolio {
    id: number | null;
    name: string;
    scope: string;
    teamId?: number | null;
    createdById?: number | null;
    isDraft: boolean;
    tempId?: string;
}

export interface IPortfolioWithVessels extends IPortfolio {
    portfolioVesselsImoList: number[] | null;
    isOwnPortfolio?: boolean;
}

// Item and Portfolio Interfaces
export interface IPortfolioForm {
    id: number | null;
    name: string;
    scope: string;
    isOwnPortfolio: boolean;
    isDraft: boolean;
    tempId?: string;
}

export interface IPortfolioWithVesselsForm extends IPortfolioForm {

    portfolioWithMsiVesselsForm: IPortfolioVesselForm[] | null;
}

export interface IPortfolioVesselForm {
    imoNumber: number;
    vesselName: string;
    sectorName: string;
    companyName: string;
}

// // Enums
// export enum ScopeOptions {
//     Personal = 'Personal',
//     Team = 'Team'
// }



// API Response structure
export interface IApiResponse<T> {
    data: T;
    message: string;
    status: 'success' | 'error';
}

export interface IApiError {
    message: string;
    statusCode: number;
}



// Enums
export enum ScopeOptions {
    Personal = 'Personal',
    Team = 'Team'
}

// Action payloads
// export interface AddPortfolioPayload {
//     portfolio: IPortfolioWithVessels;
// }

// export interface UpdatePortfolioPayload {
//     portfolio: IPortfolioWithVessels;
// }

// export interface IDeletePortfolioPayload {
//     id: number;
// }

// export interface IGetPortfolioByIdPayload {
//     id: number;
// }







// //////////////////////
// export interface IAddPortfolioPayload {
//     name: string;
//     teamId?: number | null;
//     portfolioVessels: number[];
// }

export const PORTFOLIO = 'portfolio';

export const actionTypes = {
    ADD_PORTFOLIO_REQUEST_ACTION: `${PORTFOLIO}/addPortfolioRequest`,
    UPDATE_PORTFOLIO_REQUEST_ACTION: `${PORTFOLIO}/updatePortfolioRequest`,
    DELETE_PORTFOLIO_REQUEST_ACTION: `${PORTFOLIO}/deletePortfolioRequest`,
    GET_PORTFOLIOS_REQUEST_ACTION: `${PORTFOLIO}/getPortfoliosRequest`,
    GET_PORTFOLIO_WITH_VESSELS_REQUEST_ACTION: `${PORTFOLIO}/getPortfolioWithVesselsRequest`,
    SET_SELECTED_PORTFOLIO_REQUEST_ACTION: `${PORTFOLIO}/setSelectedPortfolioRequest`,
    DISPLAY_OUTPUT_BY_PORTFOLIO_ID_REQUEST_ACTION: `${PORTFOLIO}/displayOutputByPortfolioIdRequest`,
    DELETE_DRAFT_PORTFOLIO_REQUEST_ACTION: `${PORTFOLIO}/deleteDraftPortfolioRequest`,
}